import React from 'react';

const ErrorLabel = (props) => {
    return (
        <div className="red alignLeft">
            {props.children}
        </div>
    );
};

export default ErrorLabel;
